import onSearch from './onSearch'

const MealAction = {
  onSearch
}

export default MealAction
